
{
  "fr": {
    "no-result": "Aucun résultat, veuillez vérifier l'adresse"
  }
}
